import React, { Component, PureComponent } from 'react'
import { Popup, Icon } from 'semantic-ui-react'
import DateTime from 'react-datetime'
import moment from 'moment'

export function DateButton(props) {
  let { value, onChange, placeholder = 'Aseta aika', icon = false } = props

  let classes = ['date-button-item', 'button-plain']
  if (!value) classes.push('date-button-item--placeholder')

  if (value && !moment.isMoment(value)) value = moment(value)

  let trigger = (
    <button className={classes.join(' ')}>
      {icon ? <Icon name={icon} /> : null}
      {value ? value.format('DD.MM.YYYY - HH:mm') : placeholder}
    </button>
  )

  let content = (
    <div className="date-button-portal">
      <DateTime value={value} input={false} onChange={m => onChange({ name, value: m.toDate() })} />
    </div>
  )

  return (
    <div className="date-button">
      <Popup
        trigger={trigger}
        content={content}
        style={{ margin: 0, padding: 0, borderRadius: 0 }}
        on="click"
        position="bottom right"
      />
    </div>
  )
}

export default function DateField({ value, name, onChange, disabled = false }) {
  if (value) {
    try {
      value = moment(value, 'YYYY-MM-DD HH:mm:ss.SSSZZ')
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <div className="form-field-date">
      <DateTime
        value={value}
        inputProps={{ disabled }}
        onChange={m => {
          if (disabled) return

          try {
            if (typeof m === 'string') m = moment(m)

            onChange({ name, value: m.toDate() })
          } catch (err) {
            console.log(err)
          }
        }}
      />
    </div>
  )
}
